"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.download = download;
exports.getFileURL = getFileURL;
// eslint-disable-next-line prefer-regex-literals
var urlProtocolRegExp = /^https?:\/\//;
function getFileURL(file, getPath) {
  var fileURL = file.url;
  if (fileURL) {
    if (!urlProtocolRegExp.test(fileURL)) {
      return "http://".concat(fileURL);
    }
    return fileURL;
  }
  if (file.onClick) {
    return null;
  }
  var downloadableFile = file;
  var filePath = getPath('file', {
    organizationId: downloadableFile.organizationId,
    groupId: downloadableFile.groupId,
    assetId: downloadableFile.assetId,
    version: downloadableFile.version,
    fileClassifier: downloadableFile.classifier,
    packaging: downloadableFile.packaging
  });
  var sha = downloadableFile.sha1 ? downloadableFile.sha1 : Date.now().toString();
  return "".concat(filePath, "/?sha=").concat(sha);
}
function download(file, isStudio, getPath) {
  if (file.onClick) {
    file.onClick();
    return;
  }
  var fileURL = getFileURL(file, getPath);
  if (isStudio) {
    // We need to ensure that analytics calls are made before a redirection
    // and as segment does not provide a trustworthy callback, we use a timeout
    setTimeout(function () {
      global.location.href = fileURL;
    }, 1000);
  } else {
    global.open(fileURL, '_blank');
  }
}
//# sourceMappingURL=files.js.map